import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  Button,
  ContentLayout,
  Content,
  InputBox,
  ListTable,
  SearchFilter,
  Img,
  RadioBox,
  CheckBox,
} from "@adminComponents";
import * as Datas from "@adminData";
import React, {useEffect, useState} from "react";
import {useSetRecoilState} from "recoil";
import {states} from "@recoils";
import {useAdminNav} from "@hook";
import {adminApi, utils} from "@utils";
import styles from "./style.module.scss";
import {AdminScreenId} from "@assets";
import moment from "moment";
import _ from "lodash";

export default function Page() {
  const setAlertModal = useSetRecoilState(states.alertState);
  const {getParams, navigate} = useAdminNav();
  const {searchTxt: paramsSearchTxt, page: paramsPage = 1} = getParams<{
    searchTxt?: string;
    page?: number;
  }>();
  const [searchTxt, setSearchTxt] = useState(paramsSearchTxt);
  const [listData, setListData] =
    useState<Datas.ResultPagingResponse<Datas.INoticeListResponse[]>>();

  async function getList({page = 1}: {page?: number} = {}) {
    try {
      const {data, success, message} = await adminApi.notice.getList({
        page,
        searchTxt,
      });
      if (success) {
        setListData(data);
      } else {
        setAlertModal({
          isVisible: true,
          title: message || "오류가 발생했습니다",
        });
      }
    } catch (error) {
      console.error("getList error", error);
    }
  }

  function goToDetail({data}: {data?: Datas.INotice} = {}) {
    navigate({
      url: AdminScreenId.NOTICE_DETAIL,
      params: {no: data?.no},
      state: {data},
    });
  }

  function goToListPage(params: {
    group?: string;
    group2?: string;
    searchTxt?: string;
    page?: number;
  }) {
    navigate({
      url: AdminScreenId.NOTICE,
      params,
    });
  }

  useEffect(() => {
    getList({page: paramsPage});
  }, [location.search]);

  return (
    <div className={styles.container}>
      <ContentLayout title={"공지사항"}>
        <SearchFilter
          left={[
            <InputBox
              key={1}
              value={searchTxt}
              onValue={setSearchTxt}
              onEnter={() => {
                goToListPage({
                  page: 1,
                  searchTxt,
                });
              }}
              rightContent={
                <div
                  style={{display: "flex"}}
                  onClick={() => {
                    goToListPage({
                      page: 1,
                      searchTxt,
                    });
                  }}>
                  <FontAwesomeIcon icon={faSearch} />
                </div>
              }
            />,
          ]}
          right={[<Button key={0} text="신규등록" onClick={goToDetail} />]}
        />
        <Content>
          <>
            <ListTable
              paging={listData?.page}
              getList={({page: newPage}) => {
                goToListPage({
                  page: newPage,
                  searchTxt,
                });
              }}>
              <thead>
                <tr>
                  <th>제목</th>
                  <th>내용</th>
                  <th>등록일</th>
                </tr>
              </thead>
              <tbody>
                {(listData?.result || []).length === 0 ? (
                  <tr>
                    <td colSpan={3}>조회된 내용이 없습니다.</td>
                  </tr>
                ) : (
                  <>
                    {(listData?.result || []).map(item => {
                      return (
                        <tr
                          key={item.no}
                          onClick={() => goToDetail({data: item})}>
                          <td>{item.title}</td>
                          <td>{item.content}</td>
                          <td>
                            {moment(item.created_at).format("YYYY-MM-DD")}
                          </td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            </ListTable>
          </>
        </Content>
      </ContentLayout>
    </div>
  );
}
